import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../Chart';

import { scatterChartConfiguration } from './utilities/helpers';

const ScatterChart = ({ onChartCallback, series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, scatterChartConfiguration, {
        series,
        type: 'scatter',
        xAxis,
        yAxis,
        ...props,
      })}
      {...props}
    />
  );
};

ScatterChart.propTypes = {
  onChartCallback: PropTypes.func,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default ScatterChart;
